<template>
    <div class="liveplayer_channel_list" id="play_list">
        <div class="player__control_chanels_list">
            <div class="playList_container">
                <div class="playList_header">
                    <div class="header_title">
                        <span>{{ $t('Playlist') }}</span>
                    </div>
                    <div class="close_play_list" @click="actCloseList(false)">
                        <ClosePopup />
                    </div>
                </div>
                <div class="playList_body">
                    <div class="chanel_programs_list">
                        <div class="peograms_list placeholder" v-if="!playList || playList.length <= 0">
                            <WaveLoader :loaderHeight="loaderHeight" />
                        </div>
                        <ul class="peograms_list" v-else id="programsList">
                            <li v-for="(channel, index) in playList" :key="index" class="single_program"
                                @click="actProgramPlay(channel, index)">
                                <div class="poster_img">
                                    <img :src="getLowPoster(channel)" />
                                </div>
                                <div class="info_block">
                                    <div class="program_title">
                                        {{ channel.title || channel.defaulttitle }}
                                    </div>
                                    <div class="program_desc" v-if="channel.longdescription || channel.shortdescription">
                                        {{ channel.longdescription || channel.shortdescription }}</div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
import PlaybackUtilities from "@/mixins/playbackUtilities.js";
import Utility from "@/mixins/Utility.js";
import { eventBus } from "@/eventBus";
import { store } from "@/store/store";

export default {
    name: 'ChannelList',
    props: ['liveplayerpayload', 'episodesList', 'seasonsData'],
    components: {
        WaveLoader: () => import( /* webpackChunkName: "waveLoader" */ "@/components/Loaders/WaveLoader.vue"),
        ChanelListSvg: () => import(/* webpackChunkName: "chanelListSvg" */ "@/components/SvgImages/ChanelListSvg.vue"),
        ClosePopup: () => import(/* webpackChunkName: "closePopup" */ "@/components/SvgImages/ClosePopup.vue"),
        episodeCard: () => import(/* webpackChunkName: "description" */ "@/components/DetailPage/episodeCard.vue"),
    },
    computed: {
        ...mapGetters(["appConfig", "getActivePlaylist"]),
    },
    data() {
        return {
            placeHolder: {
                portrait: require("@/assets/placeholder-port.svg"),
                landScape: require("@/assets/placeholder-lands.svg"),
            },
            generData: null,
            selectedGenerIndex: 0,
            totalChannelcount: null,
            loaderHeight: "2.5rem",
            activeCategoryChanelList: null,
            playList: [],
            currentPageNum: 1,
            selectedGenre: 'ALL CATEGORIES',
            chanelCategoryData: [],
            channelListActive: false,
            seasonsList: [],
            seasonNum: 1
        }
    },
    created() {
    },
    mounted() {
        this.playList = this.episodesList || [];
    },
    methods: {
        ...mapActions([
            "listContent",
            "listGenerContent",
            "getContent",
        ]),
        getLowPoster(item) {
            let returnImage = this.placeHolder.landScape;
            let index =
                item &&
                item.poster &&
                item.poster.findIndex((data) => {
                    return data.postertype === "LANDSCAPE";
                });
            if (index > -1) {
                item.poster[index].filelist.filter((lowImg) => {
                    if (lowImg && lowImg.quality === "LOW" || lowImg.quality === "SD" || lowImg.quality === "HD") {
                        returnImage = lowImg.filename;
                    }
                });
            }
            //  else {
            //   item.poster[0].filelist.filter((el) => {
            //     if (el.quality === "THUMBNAIL") {
            //       returnImage = el.filename;
            //     }
            //   });
            // }
            return returnImage;
        },
        async actProgramPlay(program, i) {
          const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          // this.content.watchedTime = await this.getContentProgress(this.content);
          let uriData = null;
          const urlencoded = new URLSearchParams();
          if(isSafari) {
              uriData = await this.parseHlsManifest(program.streamUrl);
              if(uriData) {
                  urlencoded.append("keyid", uriData[0]);
                  urlencoded.append("keyiv", uriData[1]);
              }
          }
          urlencoded.append("contentid", program.objectid);
          urlencoded.append("ios", isSafari ? true : false);
          urlencoded.append("seclevel", "SW");
          let drmPromise = store.dispatch("actGetDRMToken", urlencoded);
          Promise.all([drmPromise])
          .then(async ([drmRes]) => {
              let contentData = program;
              contentData['drmTokenResp'] = drmRes.data;
            this.$emit('actFromChannelList', program, i);
            this.channelListActive = !this.channelListActive;
          })
          .catch((err) => {
              console.log("err", err);
          });
        },
        actCloseList(type) {
            this.chanelCategoryData = [];
            this.$emit('closePlayList', false);
        },
    },
    beforeDestroy () {
        this.chanelCategoryData = [];
        window.removeEventListener('scroll', this.handleScroll);
        // eventBus.$off("channelListData");
    },
    watch: {
        episodesList(data) {
            this.playList = data;
            this.playList = this.episodesList;
        }
    },
    mixins: [PlaybackUtilities, Utility],

}
</script>

<style scoped lang="scss">
.player__control_chanels_list {
    width: 100%;
    height: 75vh;
    // position: absolute;
    z-index: 2;
    color: azure;
    display: flex;
    gap: 0.6rem;
    padding: 0.8rem;

    .playList_container {
        padding: 0.5rem;
        width: auto;
        // border: 2px solid #999;
        border-radius: 0.5rem;
        // background: rgb(55 55 55 / 30%);
        background: rgb(0 0 0 / 30%);
        box-shadow: 0px 0px 8px 0px rgb(65 49 49 / 75%);
        -webkit-box-shadow: 0px 0px 8px 0px rgb(65 49 49 / 75%);
        -moz-box-shadow: 0px 0px 8px 0px rgb(65 49 49 / 75%);
        width: clamp(75%, (100% - 30px), 85%);
        height: fit-content;
        .playList_header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding: 0 0.5rem;
            font-size: 1.3rem;
        }

        .close_play_list {
            padding: 0.2rem;
            cursor: pointer;
        }

        .playList_body {
            padding: 0.5rem;
            width: 100%;
            display: flex;
            gap: 0.5rem;
            // height: calc(100% - 30px);

            .chanels_category_list {
                background: rgba(255, 255, 255, 0.35);
                box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
                backdrop-filter: blur(5px);
                -webkit-backdrop-filter: blur(20px);
                border-radius: 5px;
                border: 1px solid rgba(255, 255, 255, 0.18);
                font-size: 1.2rem;
                display: flex;
                align-items: center;
            }

            .chanel_programs_list {
                background: rgba(255, 255, 255, 0.35);
                box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
                backdrop-filter: blur(5px);
                -webkit-backdrop-filter: blur(20px);
                border-radius: 5px;
                border: 1px solid rgba(255, 255, 255, 0.18);
                // height: 100vh;
                font-size: 1rem;
                display: flex;
                align-items: center;
                height: calc(100vh - 100px);
                overflow: scroll;
                .peograms_list {
                    height: calc(100% - 30px);
                    overflow-y: auto;
                    overflow-x: hidden;
                    height: calc(100% - 100px);
                    overflow-y: auto;
                    overflow-x: hidden;
                    .single_program {
                        padding: 0.3rem 3rem !important;
                        display: flex;
                        gap: 0.35rem;
                        position: relative;
                        align-items: center;
                        cursor: pointer;
                        .poster_img {
                            display: flex;
                            img {
                                width: 6rem;
                                aspect-ratio: 16/9;
                            }
                        }
                        .info_block {
                            display: flex;
                            flex-direction: column;
                            gap: 0.3rem;
                            padding: 0.4rem;
                            .program_title {
                                color: #FFFFFF;
                                font-size: clamp(0.75rem, 2vw - 0.8rem, 0.85rem);
                                font-weight: 600;
                            }
                            .program_desc {
                                color: #f9f9f9ee;
                                font-size: 0.7rem;
                                font-weight: 400;
                                width: 100%;
                                height: 3em;
                                line-height: 1.5em;
                                overflow: hidden;
                                display: -webkit-box;
                                -webkit-box-orient: vertical;
                                -webkit-line-clamp: 2;
                                text-overflow: ellipsis;
                            }
                        }
                        &:hover {
                            background: rgba(0, 0, 0, 30%);
                        }
                    }
                }
            }
        }
    }
}

.channelno {
    position: absolute;
    right: 3px;
}

.active {
    background: linear-gradient(to right, rgba(184, 20, 0, 1), rgba(255, 0, 0, 1), rgba(184, 20, 0, 1));
}

.placeholder {
    width: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
}

ul li {
    margin: 0.6rem 0rem;
}
</style>